import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RepayCardPage } from './repay-card.page';

const routes: Routes = [
  {
    path: '',
    component: RepayCardPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RepayCardPageRoutingModule {} 